import React from 'react'
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import { Button, TextField } from '@material-ui/core';
import PublishIcon from '@material-ui/icons/Publish';
import { Box } from '../../UI'
import TextBox from '../../UI/TextBox'

export default function SummaryTable({ data }) {
    const { description } = data;
    const [text, setText] = React.useState('');

    React.useEffect(() => {
        let summary = '';
        description.forEach(line => summary += line + '\n\n');
        setText(summary);
    }, [])

    return (
        <ExpansionPanel>
            <ExpansionPanelSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
            >
                <Typography variant="h6"><strong>Summary</strong></Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
                <Box display='flex' flexDirection='column' width='100%'>
                    <Box>
                        <Button variant='contained' color='primary' startIcon={<PublishIcon />} style={{ marginBottom: '0.5rem' }}>Upload Summary</Button>
                    </Box>
                    <TextBox 
                        value={text}
                        onChange={setText}
                        rows={16}
                    />
                </Box>
            </ExpansionPanelDetails>
        </ExpansionPanel>
    )
}
